import React, { useState } from 'react';
import axios from 'axios';
import './modal.css';

const EditPlotModal = ({ plot, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    status: plot.status?.toLowerCase() || 'available',
    price: plot.price,
    size: plot.size
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');


  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    setSaving(true);
    setError('');
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/plots/${plot.id}`, formData);
      if (res.data.success) {
        onUpdate({ ...plot, ...formData });
        onClose();
      }
    } catch (err) {
      console.error('Update failed:', err);
      setError('Failed to update plot. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Edit: {plot.plot_number}</h3>
        <label>Status:
          <select name="status" value={formData.status} onChange={handleChange}>
            <option value="available">Available</option>
            <option value="booked">Booked</option>
            <option value="sold">Sold</option>
          </select>
        </label>
        <label>Price:
          <input type="number" name="price" value={formData.price} onChange={handleChange} />
        </label>
        <label>Size:
          <input type="text" name="size" value={formData.size} onChange={handleChange} />
        </label>
        {error && <p style={{ color: 'red', fontSize: '13px', margin: '4px 0' }}>{error}</p>}
        <div className="modal-buttons">
          <button onClick={handleSubmit}>{saving ? 'Saving…' : 'Save'}</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default EditPlotModal;
